<template>
  <div id="app">
    <button class="lang-btn" @click="toggleLanguage">{{ isEnglish ? 'العربية' : 'English' }}</button>
    <HeaderNav :isEn="isEn" @toggle-lang="toggleLang" />
    <router-view :isEn="isEn" />
    <MainFooter />
  </div>
</template>

<script>
import HeaderNav from './components/HeaderNav.vue';
import MainFooter from './components/MainFooter.vue';

export default {
  name: 'App',
  components: {
    HeaderNav,
    MainFooter
  },
  data() {
    return {
      isEn: false
    };
  },
  methods: {
    toggleLang() {
      this.isEn = !this.isEn;
    },
    toggleLanguage() {
      this.$root.isEn = !this.$root.isEn;
    }
  },
  computed: {
    isEnglish() {
      return this.$root.isEn;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.lang-btn {
  position: fixed;
  top: 10px;
  right: 10px;
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  z-index: 1000;
}
.lang-btn:hover {
  background: #1565c0;
}
</style>
